const KEY = 'QUICK_MENU';

export { KEY };
